export default "__VITE_ASSET__L10o1pVL__"